﻿import API from '../api/apiUtils/api2';
import { ExtHubRequest } from '../authConfig';

const api = new API({
  url: `${process.env.REACT_APP_EXTHUB_DOMAIN}/api/RegEdINT`,
  scopes: ExtHubRequest,
});
const agentDeviceAPI = new API({
  url: `${process.env.REACT_APP_EXTHUB_DOMAIN}/api/AgentDevice`,
  scopes: ExtHubRequest,
});

api.createEntities([
  { name: 'GetStateApptFeesTotal' },
  { name: 'GetStateApptFees' },
  { name: 'GetAgentInformationByProducerID' },
  { name: 'GetCommissionTypeByProducerID' },
  { name: 'GetTrainingCertsByProducerID' },
  { name: 'TrackAppointments' },
  { name: 'GetProducerIDsFromNPN' },
  { name: 'GetApptStatesForTodayByNPN' },
  { name: 'OpenWellsFargoSSOLink' },
  { name: 'CheckAgencyForAppointmentExclusion' },
  { name: 'GetAgentInformation' },
  { name: 'GetLicenseInformation' },
  { name: 'GetAppointmentInformation' },
  { name: 'GetDemographicInfo' },
  { name: 'GetLOBByContractID' },
  { name: 'GetAMLRefresherInfoByContractID' },
]);

agentDeviceAPI.createEntities([
  { name: 'GetListOfAgentDeviceStatuses' },
  { name: 'SendRequestStateApprovalEmail' },
  { name: 'GetInsertAgentDeviceState' },
  { name: 'GetImportantInfo' },
  { name: 'ConfirmAgentDeviceStateExists' },
]);

const GetStateApptFeesTotal = (body) => api.endpoints.GetStateApptFeesTotal.post(body);
const GetStateApptFees = (body) => api.endpoints.GetStateApptFees.post(body);
const GetAgentInformationByProducerID = (body) =>
  api.endpoints.GetAgentInformationByProducerID.post(body);
const GetCommissionTypeByProducerID = (ProducerID) =>
  api.endpoints.GetCommissionTypeByProducerID.postMultipleQueryString([
    {
      queryParam: 'ProducerID',
      queryVal: ProducerID,
    },
  ]);
const GetTrainingCertsByProducerID = (body) =>
  api.endpoints.GetTrainingCertsByProducerID.post(body);
const TrackAppointments = (body) => api.endpoints.TrackAppointments.post(body);
const GetProducerIDsFromNPN = (body) => api.endpoints.GetProducerIDsFromNPN.post(body);
const GetApptStatesForTodayByNPN = (body) => api.endpoints.GetApptStatesForTodayByNPN.post(body);
const OpenWellsFargoSSOLink = (body) => api.endpoints.OpenWellsFargoSSOLink.post(body);
const CheckAgencyForAppointmentExclusion = (body) =>
  api.endpoints.CheckAgencyForAppointmentExclusion.post(body);
const GetAgentInformation = (body) => api.endpoints.GetAgentInformation.post(body);
const GetLicenseInformation = (body) => api.endpoints.GetLicenseInformation.post(body);
const GetAppointmentInformation = (body) => api.endpoints.GetAppointmentInformation.post(body);
const GetDemographicInfo = (ProducerID) =>
  api.endpoints.GetDemographicInfo.postMultipleQueryString([
    {
      queryParam: 'ProducerID',
      queryVal: ProducerID,
    },
  ]);
const GetLOBByContractID = (ContractID) =>
  api.endpoints.GetLOBByContractID.postMultipleQueryString([
    {
      queryParam: 'ContractID',
      queryVal: ContractID,
    },
  ]);
const GetAMLRefresherInfoByContractID = (ContractID) =>
  api.endpoints.GetAMLRefresherInfoByContractID.postMultipleQueryString([
    {
      queryParam: 'ContractID',
      queryVal: ContractID,
    },
  ]);

const GetListOfAgentDeviceStatuses = (body) =>
  agentDeviceAPI.endpoints.GetListOfAgentDeviceStatuses.post(body);
const SendRequestStateApprovalEmail = (
  AgentName,
  AgencyName,
  ResidentState,
  RequestState,
  RequestDetails
) =>
  agentDeviceAPI.endpoints.SendRequestStateApprovalEmail.postMultipleQueryString([
    {
      queryParam: 'AgentName',
      queryVal: AgentName,
    },
    {
      queryParam: 'AgencyName',
      queryVal: AgencyName,
    },
    {
      queryParam: 'ResidentState',
      queryVal: ResidentState,
    },
    {
      queryParam: 'RequestState',
      queryVal: RequestState,
    },
    {
      queryParam: 'RequestDetails',
      queryVal: RequestDetails,
    },
  ]);
const GetInsertAgentDeviceState = (body) =>
  agentDeviceAPI.endpoints.GetInsertAgentDeviceState.post(body);
const GetImportantInfo = () => agentDeviceAPI.endpoints.GetImportantInfo.get();
const ConfirmAgentDeviceStateExists = (body) =>
  agentDeviceAPI.endpoints.ConfirmAgentDeviceStateExists.post(body);

export {
  GetStateApptFeesTotal,
  GetStateApptFees,
  GetAgentInformationByProducerID,
  GetCommissionTypeByProducerID,
  GetTrainingCertsByProducerID,
  TrackAppointments,
  GetProducerIDsFromNPN,
  GetApptStatesForTodayByNPN,
  OpenWellsFargoSSOLink,
  CheckAgencyForAppointmentExclusion,
  GetAgentInformation,
  GetLicenseInformation,
  GetAppointmentInformation,
  GetDemographicInfo,
  GetLOBByContractID,
  GetAMLRefresherInfoByContractID,
  GetListOfAgentDeviceStatuses,
  SendRequestStateApprovalEmail,
  GetInsertAgentDeviceState,
  GetImportantInfo,
  ConfirmAgentDeviceStateExists,
};
